import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=3d7d24fe"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=3d7d24fe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7d24fe')) {
      api.createRecord('3d7d24fe', component.options)
    } else {
      api.reload('3d7d24fe', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=3d7d24fe", function () {
      api.rerender('3d7d24fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/Layout.vue"
export default component.exports